import { useEffect, useState } from "react";
import { EyeOff, Eye, Heart } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";
import { ListingCard } from "@/components/ListingCard";
import { ListingDetail } from "@/components/ListingDetail";
import { useLikes } from "@/context/LikesContext";
import { QuickAddToTrip } from "@/components/QuickAddToTrip";

export function WantToVisit({ items, isMe, name }) {
  const { keys } = useLikes();
  const [open, setOpen] = useState(null);
  const { user } = useAuth();
  const family = isMe && user?.family_plan;
  const [hidden, setHidden] = useState(new Set());
  const [mine, setMine] = useState(new Set());
  useEffect(() => {
    if (family) api.get("/likes/hidden").then((r) => { setHidden(new Set(r.data.hidden)); setMine(new Set(r.data.mine)); }).catch(() => {});
  }, [family]);
  const toggleHide = async (key) => {
    const on = !hidden.has(key);
    try {
      await api.patch("/likes/hidden", { hidden: on }, { params: { place_key: key } });
      setHidden((s) => { const n = new Set(s); if (on) n.add(key); else n.delete(key); return n; });
      toast.success(on ? "Hidden from your family — it's a surprise" : "Visible to your family again");
    } catch (e) { toast.error(errorMessage(e)); }
  };
  const shown = isMe ? items.filter((i) => keys.has(i.place_key)) : items;

  if (shown.length === 0) {
    return (
      <p data-testid="profile-liked-empty" className="text-sm text-slate-500 rounded-2xl border border-dashed border-[#26334D] p-10 text-center">
        <Heart className="h-5 w-5 mx-auto mb-2 text-[#FF3B6B]" />
        {isMe ? "Tap the heart on any place while exploring to save it here." : `${name} hasn't hearted any places yet.`}
      </p>
    );
  }
  return (
    <>
      <div data-testid="profile-liked-grid" className="grid sm:grid-cols-2 gap-5">
        {shown.map((item, i) => (
          <div key={item.place_key}>
            {item.city && <p className="text-xs text-slate-500 mb-1.5 pl-1">{item.city}</p>}
            <ListingCard item={item} index={i} onOpen={setOpen} />
            {isMe && <QuickAddToTrip item={item} />}
            {family && mine.has(item.place_key) && (
              <button type="button" data-testid={`heart-surprise-${i}`} onClick={() => toggleHide(item.place_key)}
                className={`mt-2 text-xs flex items-center gap-1 ${hidden.has(item.place_key) ? "text-[#FFB800]" : "text-slate-400 hover:text-white"}`}>
                {hidden.has(item.place_key) ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
                {hidden.has(item.place_key) ? "Hidden from family (surprise)" : "Hide from family"}
              </button>
            )}
          </div>
        ))}
      </div>
      <ListingDetail item={open} onClose={() => setOpen(null)} city={open?.city} />
    </>
  );
}
